import React from "react";
import { Fab } from "@mui/material";
import { styled } from "@mui/material/styles";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import { useDispatch, useSelector } from "react-redux";
import { selectGameObject } from "../../gamestate/gameStateSlice";
import { advanceFinalRevealStep } from "../../gamestate/GameState";
import { requestNarrationForCurrentStep } from "../../host/moments/FinalPlayerReveal";

const StyledFab = styled(Fab)(({ theme }) => ({
  position: "fixed",
  left: theme.spacing(4),
  bottom: theme.spacing(4),
  backgroundColor: "rgba(255,255,255,0.15)",
  color: "#ffffff",
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.3)",
  },
}));

const FabIcon = styled(SkipNextIcon)(({ theme }) => ({
  marginRight: theme.spacing(0.5),
}));

/**
 * Manual advance for the final reveal sequence: tick currentStep forward
 * AND request the new step's narration. The narration request is required
 * because auto-advance fires it from the prior step's onComplete — when
 * onComplete didn't fire (the case the FAB is for), the next step would
 * otherwise be left without a narration to play.
 */
const FinalRevealAdvanceFab = () => {
  const dispatch = useDispatch();
  const gameObject = useSelector(selectGameObject);

  const onClick = async () => {
    if (!gameObject) return;
    const newReveal = await advanceFinalRevealStep(gameObject, dispatch);
    if (!newReveal) return;
    await dispatch(requestNarrationForCurrentStep(gameObject.id));
  };

  return (
    <StyledFab
      variant="extended"
      size="small"
      onClick={onClick}
    >
      <FabIcon />
      Advance
    </StyledFab>
  );
};

export { FinalRevealAdvanceFab };
